import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reviewKeys } from "@/application/query-keys/review-keys";
import { reviewFlowsRepository } from "@/infrastructure/repositories/review-flows-supabase-repository";
import type { ReviewFlowCreate } from "@/infrastructure/repositories/review-flows-supabase-repository";
import type { ReviewFlowRow } from "@/infrastructure/supabase/database.types";

/** Create the content row for a hand-authored block-v item (first save in the drawer). */
export function useCreateReviewFlow() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (row: ReviewFlowCreate) => reviewFlowsRepository.create(row),
    onSuccess: (row: ReviewFlowRow) => {
      queryClient.setQueryData(reviewKeys.flow(row.flow_id), row);
    },
  });
}
